import React from 'react'

export const WorkViewsSkeleton = () => {
  return (
    <div className='flex flex-col bg-base-100'>
      <div className='w-full h-[49px] border-b border-t flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-1/3' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-3 w-1/4 flex justify-between items-center'>
            <div className='skeleton h-2 w-5/6'></div>
            <div className='h-full w-1/6 border-r-[2px]'></div>
          </div>
          <div className='h-3 w-1/4 flex justify-between items-center'>
            <div className='skeleton h-2 w-5/6'></div>
            <div className='h-full w-1/6 border-r-[2px]'></div>
          </div>
          <div className='h-3 w-1/4 flex justify-between items-center'>
            <div className='skeleton h-2 w-5/6'></div>
            <div className='h-full w-1/6 border-r-[2px]'></div>
          </div>
          <div className='h-3 w-1/4 flex justify-between items-center'>
            <div className='skeleton h-2 w-5/6'></div>
            <div className='h-full w-1/6 border-r-[2px]'></div>
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-full' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-full' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/5' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/6' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/5' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/5' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/5' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-full' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-full' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
        </div>
      </div>
      <div className='w-full h-[42px] border-b flex justify-center items-center'>
        <div className='w-[385px] border-r h-full flex justify-center items-center'>
          <div className='p-3 w-full'>
            <div className='skeleton h-2 w-full' />
          </div>
        </div>
        <div className='w-full p-3 flex flex-row gap-3'>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/2' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/3' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/4' />
          </div>
          <div className='h-2 w-1/4'>
            <div className='skeleton h-2 w-1/5' />
          </div>
        </div>
      </div>
    </div>
  )
}
